import { Injectable } from "@angular/core"
import { AngularFireAuth } from "@angular/fire/auth"
import {
  AngularFirestore,
} from "@angular/fire/firestore"
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from "@angular/router"
import { Observable } from "rxjs"
import { map } from "rxjs/operators"

import { AuthService } from "./auth.service"
import { DataService } from "./data.service"

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanActivateChild {
  public get company(): string { return this.dataService.company.value }
  public set company(company: string) { this.dataService.company.next(company) }
  public get uid(): string { return this.dataService.uid.value }
  public set uid(uid: string) { this.dataService.uid.next(uid) }
  public get roles(): string[] { return this.dataService.roles.value }
  public set roles(roles: string[]) { this.dataService.roles.next(roles) }

  constructor(
    private dataService: DataService,
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    private router: Router,
    private authService: AuthService,
  ) {
  }

  // canActivate(): Observable<boolean> {
  // return this.afAuth.authState
  //   .take(1)
  //   .map(authState => !!authState)
  //   .do(auth => !auth ? this.router.navigate(['pages/login']) : true);
  // }

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.afAuth.authState.pipe(
      map(user => {
        if (user != null) {
          // this.checkUserRoles(user.uid);
          return true
        } else {
          // this._store.dispatch(new LayoutOpenLoginAction());
          this.router.navigate(["/pages/login"])
          return false
        }
      }),
    )
  }

  public async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    const user = this.getUser()
    if (user === null || user.roles.length === 0) {
      this.router.navigate(["/pages/login"])
      return false
    } else {
      if (state.url.startsWith("/pages")) {
        return true
      } else if (state.url.startsWith("/super")) {
        // Check user roles for super
        if (user.roles.includes("SuperUser")) {
          return true
        }
        this.router.navigate(["forbidden"])
      } else if (state.url.startsWith("/tester")) {
        if (
          user.roles.includes("PartnerSeniorManager") ||
          user.roles.includes("SeniorManager") ||
          user.roles.includes("PartnerManager") ||
          user.roles.includes("Manager") ||
          user.roles.includes("PartnerTester") ||
          user.roles.includes("Tester") ||
          user.roles.includes("SuperUser")
        ) {
          return true
        } else {
          this.router.navigate(["forbidden"])
        }

        // Check user roles for tester
      } else if (state.url.startsWith("/captain")) {
        if (
          user.roles.includes("PartnerSeniorManager") ||
          user.roles.includes("SeniorManager") ||
          user.roles.includes("PartnerManager") ||
          user.roles.includes("Manager") ||
          user.roles.includes("SuperUser")
        ) {
          if (
            state.url.includes("/captain/captains") ||
            state.url.includes("/captain/manageTesters") ||
            state.url.includes("/captain/testerMetrics")
          ) {
            if (
              user.roles.includes("PartnerSeniorManager") ||
              user.roles.includes("SeniorManager") ||
              user.roles.includes("SuperUser")
            ) {
              return true
            } else {
              this.router.navigate(["forbidden"])
              return false
            }
          } else {
            return true
          }
        }
        this.router.navigate(["forbidden"])
      } else if (state.url.startsWith("/accountManager")) {
        // Check user roles for manager
        if (
          user.roles.includes("AccountManager") ||
          user.roles.includes("AccountBillingManager") ||
          user.roles.includes("SuperUser")
        ) {
          return true
        }
        this.router.navigate(["forbidden"])
        // Navigate to login page OR navigate to forbidden
      } else if (state.url.startsWith("/developer")) {
        // Check user roles for manager
        if (
          user.roles.includes("Developer") ||
          user.roles.includes("SuperUser") ||
          user.roles.includes("Admin")
        ) {
          return true
        }
        this.router.navigate(["forbidden"])
        // Navigate to login page OR navigate to forbidden
      } else if (state.url.startsWith("/forbidden")) {
        // Check user roles for manager
        return true
        // Navigate to login page OR navigate to forbidden
      } else {
        // Client pages
        if (
          user.roles.includes("Admin") ||
          user.roles.includes("BillingAdmin") ||
          user.roles.includes("User") ||
          user.roles.includes("SuperUser") ||
          user.roles.includes("Developer")
        ) {
          return true
        }
        this.router.navigate(["forbidden"])
        return false
      }
    }
  }

  private getUser(): { roles: string[] } {
    if (this.roles) {
      return { roles: this.roles }
    }
    return { roles: [] }
  }
}
